import { render, staticRenderFns } from "./FilterManufactureWhite.vue?vue&type=template&id=2d523033"
import script from "./FilterManufactureWhite.vue?vue&type=script&lang=js"
export * from "./FilterManufactureWhite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports